/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Project.Entrypoint
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
} from '@tanstack/vue-query';
import {
  unref,
} from 'vue';

import { customInstance } from '../../../lib/axios-instance';

import type {
  ResetPasswordCommand,
  UserDto,
} from '../../../lib/api/schemas';
import type { ErrorType, BodyType } from '../../../lib/axios-instance';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import type {
  MaybeRef,
} from 'vue';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const authMe = (

  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  return customInstance<UserDto>(
    { url: '/auth/me', method: 'GET', signal,
    },
    options);
};

export const getAuthMeQueryKey = () => {
  return ['auth', 'me'] as const;
};

export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<void>>(options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAuthMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>;
};

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>;
export type AuthMeQueryError = ErrorType<void>;

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<void>>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const authResetPassword = (
  resetPasswordCommand: MaybeRef<ResetPasswordCommand>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  resetPasswordCommand = unref(resetPasswordCommand);

  return customInstance<void>(
    { url: '/auth/reset', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordCommand, signal,
    },
    options);
};

export const getAuthResetPasswordMutationOptions = <TError = ErrorType<unknown>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, { data: BodyType<ResetPasswordCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, { data: BodyType<ResetPasswordCommand> }, TContext> => {
  const mutationKey = ['authResetPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResetPassword>>, { data: BodyType<ResetPasswordCommand> }> = (props) => {
    const { data } = props ?? {};

    return authResetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authResetPassword>>>;
export type AuthResetPasswordMutationBody = BodyType<ResetPasswordCommand>;
export type AuthResetPasswordMutationError = ErrorType<unknown>;

export const useAuthResetPassword = <TError = ErrorType<unknown>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof authResetPassword>>, TError, { data: BodyType<ResetPasswordCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof authResetPassword>>,
  TError,
  { data: BodyType<ResetPasswordCommand> },
  TContext
> => {
  const mutationOptions = getAuthResetPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
